/**
 * Funnel events of the free tool (SLP-2285).
 *
 * One GTM event, `CE_freeTool`, with the step in `ep_name`. The container forwards only events
 * matching `CE_.*` to GA4 (see signnow/helpers/analytics-events.ts), so the step names from the
 * ticket travel as a parameter instead of as event names GTM would drop.
 */

export type FreeToolStep =
  | 'tool_start'
  | 'type_used'
  | 'draw_used'
  | 'upload_used'
  | 'download_click'
  | 'limit_reached'
  | 'cta_to_product_click';

export const FREE_TOOL_EVENT = 'CE_freeTool';

export function trackFreeTool(step: FreeToolStep, tool: string, detail?: string): void {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event: FREE_TOOL_EVENT, ep_name: step, ep_tool: tool, ...(detail ? { ep_value: detail } : {}) });
}
